import React from "react";
import heroHome from "../assets/building.jpg";

function Hero2({ setPage }) {
  return (
    <section className="relative min-h-screen flex items-end overflow-hidden ">
      {/* Background Image */}
      <img
        src={heroHome}
        alt="Modern luxury home"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent" />

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 pb-24 lg:pb-32 max-w-7xl px-6">
        <div className="max-w-3xl">
          <p className="uppercase tracking-[3px] text-teal-400 font-semibold text-sm mb-4">
            Construction & Interiors
          </p>

          <h1 className="text-6xl md:text-7xl lg:text-[92px] leading-[1.05] font-light tracking-tighter text-white mb-8">
            Modern homes, <span className="font-medium italic">built with discipline.</span>
          </h1>

          <p className="text-lg md:text-xl text-white/80 max-w-lg mb-10">
            Meridian designs, builds, renovates, and finishes quiet luxury residences 
            with one accountable team from first sketch to final handover.
          </p>

          <div className="flex flex-wrap gap-4">
            <button
              onClick={() => setPage("projects")}
              className="bg-teal-600 hover:bg-teal-700 transition-all text-white px-8 py-4 rounded-[2px] flex items-center gap-3 font-medium group"
            >
              View Projects
              <span className="text-xl group-hover:translate-x-1 transition">↗</span>
            </button>

            <button
              onClick={() => setPage("contact")}
              className="border border-white/60 hover:border-white text-white px-8 py-4 rounded-[2px] transition-all"
            >
              Start a Build
            </button>
          </div>
        </div>

        {/* Stats */}
        <div className="flex gap-12 mt-20 text-white">
          <div>
            <div className="text-4xl font-semibold">18</div>
            <div className="text-sm tracking-widest uppercase mt-1 opacity-70">Years</div>
          </div>
          <div>
            <div className="text-4xl font-semibold">240+</div>
            <div className="text-sm tracking-widest uppercase mt-1 opacity-70">Homes</div>
          </div>
          <div>
            <div className="text-4xl font-semibold">98%</div>
            <div className="text-sm tracking-widest uppercase mt-1 opacity-70">Referral</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero2;